import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestParamsCorrector = (requestParams) => ({
    draftIds: requestParams.draftIds,
    pageNumber: requestParams.pageNumber,
    pageSize: requestParams.pageSize,
    sortOptions: requestParams.sortOptions || null,
    provinceIds: requestParams.provinceIds || null,
    cityIds: requestParams.cityIds || [],
    storeIds: requestParams.storeIds || null,
    retailerIds: requestParams.retailerIds || null,
    jobIds: requestParams.jobIds || null,
    helperJobIds: requestParams.helperJobIds || null,
    productIds: requestParams.productIds || null,
    traits: requestParams.traits || null,
    hours: requestParams.hours || null,
    workerIds: requestParams.workerIds || null,
    supervisorIds: requestParams.supervisorIds || null,
    startDate: requestParams.startDate || null,
    endDate: requestParams.endDate || null,
    exceptions: requestParams.exceptions || null,
    includeFilterLists: true
});


export const getDraftSchedules = () =>
    axios.get(`${apiUrl}draftSchedules?includeInactive=true`);

export const getDraftSchedule = draftId =>
    axios.get(`${apiUrl}draftSchedules/${draftId}`);

/**
 * Save new draft.
 * @param {Object} data
 * @returns {Object}
 */
export const createDraftSchedule = (data) =>
    axios.post(`${apiUrl}draftSchedules`, data);

export const setDraftStatusRequest = (draftId, status) =>
    axios.post(`${apiUrl}draftSchedules/${draftId}/status`, {
        status
    });

export const addStoresToDraft = (draftId, storeId) =>
    axios.post(`${apiUrl}draftSchedules/${draftId}/stores`, { storeId });

export const deleteStoreFromDraft = (draftId, id) =>
    axios.delete(`${apiUrl}draftSchedules/${draftId}/stores/${id}`);

export const addJobsToDraft = (draftId, jobProductId) =>
    axios.post(`${apiUrl}draftSchedules/${draftId}/jobs`, { jobProductId });

export const deleteJobFromDraft = (draftId, id) =>
    axios.delete(`${apiUrl}draftSchedules/${draftId}/jobs/${id}`);

export const updateDraftJob = (id, draftId, jobProductId, helperJobProductId, serviceTypeId) =>
    axios.put(`${apiUrl}draftSchedules/${draftId}/jobs/${id}`, {
        jobProductId,
        helperJobProductId,
        serviceTypeId
    });

export const addDateToJobProductRequest = (id, startDate, endDate) =>
    axios.post(`${apiUrl}draftSchedules/jobs/${id}/dates`, {
        startDate,
        endDate
    });

export const deleteDateToJobProductRequest = id =>
    axios.delete(`${apiUrl}draftSchedules/jobs/${id}/dates`);

export const editDraftRequest = (id, name, isInactive) =>
    axios.put(`${apiUrl}draftSchedules/${id}`, {
        name,
        isInactive
    });

export const deleteDraftRequest = id =>
    axios.delete(`${apiUrl}draftSchedules/${id}`);

export const getDraftsDetailsPagedRequest = (requestParams) =>
    axios.post(`${apiUrl}draftSchedules/details-paged`, requestParamsCorrector(requestParams));

/**
 *
 * @param field
 * @param value
 * @param metadata = requestParams
 * @returns {Object}
 */
export const batchBulkEditRequest = (field, value, metadata) => {
    const requestParams = requestParamsCorrector(metadata);
    return axios.patch(`${apiUrl}draftSchedules/details/batch`, {
        field,
        value,
        metadata: requestParams
    });
};

export const requestRemoveAllWorkers = metadata => axios.patch(`${apiUrl}draftSchedules/details/removeWorkers`, {
    metadata
});

/**
 * Immediate Save for Draft Detail Fields.
 * @param {Number} draftDetailId
 * @param {String} field
 * @param {String|Number} value
 * @returns {Object}
 */
export const batchEditCellRequest = (draftDetailId, field, value) =>
    axios.patch(`${apiUrl}draftSchedules/details/${draftDetailId}`, {
        field,
        value
    });

/**
 * Remove Worker from draft detail item.
 * @param {Number} draftDetailRowId
 * @param {Number} workerRowId
 */
export const draftSchedulerWorkerDeleteRequest = (draftDetailRowId, workerRowId) =>
    axios.delete(`${apiUrl}draftSchedules/details/${draftDetailRowId}/workers/${workerRowId}`);


/**
 * Insert new worker to draft detail item.
 * @param {Number} draftDetailRowId
 * @param {Number} workerId
 * @param {Boolean} isTeamLead
 */
export const draftSchedulerWorkerInsertRequest = (draftDetailRowId, workerId, isTeamLead) =>
    axios.post(`${apiUrl}draftSchedules/details/${draftDetailRowId}/workers`, {
        id: workerId,
        isTeamLead
    });

/**
 * Update worker to draft detail item.
 * @param {Number} draftDetailRowId
 * @param {Number} workerRowId
 * @param {Number} workerId
 * @param {Boolean} isTemporary
 */
export const draftSchedulerWorkerUpdateRequest =
    (draftDetailRowId, workerRowId, workerId, isTemporary = false) =>
        axios.patch(`${apiUrl}draftSchedules/details/${draftDetailRowId}/workers/${workerRowId}`, {
            id: workerId, // worker.id
            isTemporary
        });

export const draftSchedulerFindMissingWorkersRequest =
    (jobId, metadata, helperJobId, numberOfHelpers) =>
        axios.patch(`${apiUrl}draftSchedules/details/findMissingWorkers`, {
            jobId,
            metadata,
            helperJobId,
            numberOfHelpers
        });

export const bulkReplaceWorkerRequest = (oldWorkerId, newWorkerId, metadata) => axios.patch(`${apiUrl}draftSchedules/details/bulkReplaceWorker`, {
    oldWorkerId,
    newWorkerId,
    metadata
});

export const deleteDraftsRequest = (draftIdArr) =>
    axios.post(`${apiUrl}draftSchedules/batch/delete`, draftIdArr);

export const inactivateDraftsRequest = (draftIdArr) =>
    axios.post(`${apiUrl}draftSchedules/batch/deactivate`, draftIdArr);

export const exportDraftsRequest = (draftIdArr) =>
    axios.post(`${apiUrl}draftSchedules/batch/export`, draftIdArr);

export const getReportContacts = () => axios.get(`${apiUrl}reports/contacts`, {
    responseType: "blob"
});

export const getReportJobChargeRate = () => axios.get(`${apiUrl}reports/JobChargeRateExcel`, {
    responseType: "blob"
});

export const getMerchandiserPayRate = () => axios.get(`${apiUrl}reports/MerchandiserPayRateExcel`, {
    responseType: "blob"
});

export const exportScheduleReportExcel = (data) =>
    axios.post(`${apiUrl}reports/schedule/excel`, data, {
        responseType: "blob"
    });

export const exportPickPackReportExcel = (data) =>
    axios.post(`${apiUrl}reports/pickPack/excel`, data, {
        responseType: "blob"
    });

export const exportChargeApprovalReportExcel = (data) =>
    axios.post(`${apiUrl}reports/chargeApproval/excel`, data, {
        responseType: "blob"
    });

export const getScheduleReportFields = () => axios.get(`${apiUrl}reports/schedule/fields`);

export const exportMiscChargeReportExcel = (data) =>
    axios.post(`${apiUrl}reports/MiscChargesReport`, data, {
        responseType: "blob"
    });

export const exportTravelLocationsReportExcel = (data) =>
    axios.post(`${apiUrl}reports/TravelLocationsReport`, data, {
        responseType: "blob"
    });
